import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFilePreviewSplitPanelState, FilePreviewSource } from "./definitions";

const initialState: IFilePreviewSplitPanelState = {
  selectedDocumentId: null,
  isOpen: false,
  source: null,
  gaiaObjectType: undefined,
};

export const filePreviewSplitPanelSlice = createSlice({
  name: "filePreviewSplitPanel",
  initialState,
  reducers: {
    setSelectedDocumentId: (state, action: PayloadAction<string | null>) => {
      state.selectedDocumentId = action.payload;
    },
    setSplitPanelOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setGaiaObjectType: (state, action: PayloadAction<string | undefined>) => {
      state.gaiaObjectType = action.payload;
    },
    setSource: (state, action: PayloadAction<FilePreviewSource>) => {
      state.source = action.payload;
    },
  },
});

export const {
  setSelectedDocumentId,
  setSplitPanelOpen,
  setGaiaObjectType,
  setSource,
} = filePreviewSplitPanelSlice.actions;

export default filePreviewSplitPanelSlice.reducer;
